import Vue from 'vue';
import VueRouter from 'vue-router';
import { CommonRoutes } from './Common';
import { AuditRoutes } from './Audit';
import { RestoreLogRoutes } from './RestoreLogs';
import { ODRoutes } from './OD';
import { WarRoutes } from './War';
import { BulkRoutes } from './Bulk';
import { SharedRoutes } from './shared';
import { UserAdministrationRoutes } from './UserAdministration';
import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';
import { MiscRoutes } from './Misc';
import { MtgRoutes } from './Mtg';
import { TIRoutes } from './TI';
import { TARoutes } from './TA';
import { TPRoutes } from './TP';
import { TaxCommentsRoutes } from './TaxComments';
import { MCPRoutes } from './MCP';
import { UserGuideRoutes } from './UserGuide';
import { GlRoutes } from './Gl';
import { taxRollWorkFileRoutes } from './trWorkFile';
import { Apportionment } from './apportionment';
import { SpecialTaxRoutes } from './SpecialTax';
import { DelinquentTaxRoutes } from './DelinquentTax';
import { TaxRollAdjustmentRoutes } from './TaxRollAdjustment';
import { ImportRoutes } from './import';
import { installNavigationChunkRecovery } from '../util/chunk-reload';

Vue.use(VueRouter);

/*
  '/reports' is reserve for report mode
  If required any report mode please add '/reports' at pre route
*/
const DEFAULT_TITLE = 'TM Consulting';

const routes = [
  {
    path: '/',
    name: 'Home',
    // route-level code-splitting
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/login',
    name: 'HomeLogin',
    // route-level code-splitting
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/system-config',
    name: 'System Configuration',
    meta: {
      title: 'Setting',
    },
    component: () => import('../views/common/SystemConfig.vue'),
    beforeEnter: async (to, from, next) => {
      await accessCriteria(authRoles.SettingsUsers, next);
    },
  },
  {
    path: '/system-info',
    name: 'View System Info',
    component: () => import('../views/common/SystemInfo.vue'),
    beforeEnter: async (to, from, next) => {
      await accessCriteria(authRoles.SuperAdmin, next);
    },
  },
  {
    path: '/dev-specific-config',
    name: 'Dev Specific Config',
    component: () => import('../views/common/DevSpecificConfig.vue'),
    beforeEnter: async (to, from, next) => {
      await accessCriteria(authRoles.SuperAdmin, next);
    },
  },
  {
    path: '/migration-manager',
    name: 'Migration Manager',
    component: () => import('../views/common/MigrationManager.vue'),
    beforeEnter: async (to, from, next) => {
      await accessCriteria(authRoles.SuperAdmin, next);
    },
  },
  {
    path: '/data-browser',
    name: 'Data Browser',
    meta: { title: 'Data Browser' },
    component: () => import('../views/common/DataBrowser.vue'),
    beforeEnter: async (to, from, next) => {
      await accessCriteria([...authRoles.SuperAdmin, ...authRoles.ImportExportAdmins], next);
    },
  },
  ...CommonRoutes,
  ...AuditRoutes,
  ...RestoreLogRoutes,
  ...ODRoutes,
  ...BulkRoutes,
  ...UserAdministrationRoutes,
  ...WarRoutes,
  ...SharedRoutes,
  ...MiscRoutes,
  ...MtgRoutes,
  ...TIRoutes,
  ...TARoutes,
  ...UserGuideRoutes,
  ...GlRoutes,
  ...TaxCommentsRoutes,
  ...TPRoutes,
  ...taxRollWorkFileRoutes,
  ...MCPRoutes,
  ...Apportionment,
  ...SpecialTaxRoutes,
  ...DelinquentTaxRoutes,
  ...TaxRollAdjustmentRoutes,
  ...ImportRoutes,

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

// TKT-000801 / TKT-000853: every component above is lazy-loaded, so a browser still holding
// the index.html from before a release asks for chunk filenames the server no longer has.
// Without this the navigation dies silently and the tab looks frozen. See util/chunk-reload.js.
installNavigationChunkRecovery(router);

export default router;
